import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { RecurringAvailability } from "@/models/recurring-availability.model.ts"
import { type IRecurringAvailability } from "@/interfaces/api/recurring-availability.interface.ts"
import { RecurringAvailabilityRepository } from "@/repositories/recurring-availability-repository.ts"
import { useKnownBusinessEntitiesContactsStore } from "@/store/known-business-entities-contacts.store.ts"
import { storeToRefs } from "pinia"
import { useRelatedObjectsManager } from "@/composables/socket/related-objects-manager.ts"
import type { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers.ts"

export class RecurringAvailabilityController extends GenericModelController<
  RecurringAvailability,
  IRecurringAvailability,
  RecurringAvailabilityRepository
> {
  constructor() {
    const { knownBusinessEntitiesContacts } = storeToRefs(useKnownBusinessEntitiesContactsStore())

    const { pushToRelatedObjects, removeFromRelatedObjects } = useRelatedObjectsManager(
      knownBusinessEntitiesContacts,
      (recurringAvailability: RecurringAvailability) => recurringAvailability.availabilityBucket,
      (kbec: KnownBusinessEntityContact) => kbec.availabilityBucket?.id,
      (kbec: KnownBusinessEntityContact) => kbec.availabilityBucket?.recurringAvailabilities
    )

    const storeFunctionsConfig = {
      onCreate: pushToRelatedObjects,
      onDelete: removeFromRelatedObjects
    }

    super(RecurringAvailability, storeFunctionsConfig, new RecurringAvailabilityRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      RecurringAvailability,
      null,
      pushToRelatedObjects,
      removeFromRelatedObjects
    )
  }
}
